export const Marquee = () => {
  $('#marquee').marquee({
    duration: 40000,
    gap: 0,
    delayBeforeStart: 30,
    direction: 'left',
    duplicated: true,
    pauseOnHover:true
  });
};
